// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import MainLayout from '../../layouts/MainLayout';
import Button from '../../components/Button';
import Column from '../../components/Column';
import HandsOnCompletionStatusTag from '../../components/HandsOnCompletionStatusTag';

import examReviewBg from '../../assets/images/exam-review-bg.svg';
import examReviewSubmit from '../../assets/images/exam-review-submit.svg';
import ErrorForbiddenImage from '../../assets/images/lab-error-forbidden.svg';
import examReviewFileIcon from '../../assets/images/exam-review-file-icon.svg';
import HightlightIcon from '../../assets/images/button-active.svg';
import QuestionsAllCorrectIcon from '../../assets/images/course-content-completed-pic.svg';

export const S = {
  MainLayout: styled(MainLayout)`
    user-select: none;
  `,
  SubmitContainer: styled.div`
    padding: 24px 100px;
    background-image: url(${examReviewBg});
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    position: fixed;
  `,
  Container: styled.div`
    padding: 24px 100px;
  `,
  Wrapper: styled.div`
    width: 100%;
    margin: 50px 0;
  `,
  ExamReviewHeader: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    color: #434343;
    padding: 50px 60px;
    border-radius: 20px;
    border-top: 2px solid orange;
    border-bottom: 2px solid orange;
  `,
  ExamReviewTitle: styled.div`
    font-size: 18px;
  `,
  ExamReviewUserName: styled.p`
    margin-bottom: 30px;
    font-size: 22px;
  `,
  ExamReviewExamName: styled.p`
    padding-bottom: 20px
  `,
  ExamReviewSelect: styled.div`
    font-size: 18px;
    padding-right: 8%;
  `,
  ExamReviewExamStatus: styled.div`
    display: flex;
    align-items: center;
  `,
  CompletionStatusTag: styled(HandsOnCompletionStatusTag)``,
  ExamNumber: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,
  ExamReviewScore: styled.p`
    margin: 0 15px 20px;
  `,
  ExamReviewCorrect: styled.p`
    margin: 0 15px;
  `,
  ExamReviewWrong: styled.p`
    margin: 0 15px;
  `,
  TabNavigation: styled.div`
    display: flex;
    border-bottom: 1px solid #7D7D7D;
    margin-top: 50px;
  `,
  TabLink: styled.p<{ isAcitve: boolean }>`
    padding: 5px 10px;
    border: 1px solid #7D7D7D;
    border-bottom: none;
    border-radius: 5px 5px 0 0;
    cursor: pointer;
    background: #fff;
    ${props => props.isAcitve ? `
      color: #2c2c2c;
      border-left: 5px solid orange;
      padding-left: 6px;
    ` : `
      color: #0e0e0e;
    `}
  `,

  // Multi Select Section
  ExamScoreWrap: styled.div`
  `,
  ExamTopicArea: styled.div`
    border-radius: 14px;
    padding: 39px 55px 15%;
  `,
  ExamTopicTitle: styled.p`
    font-weight: 700;
    font-size: 36px;
    color: #5C5C5C;
    margin-bottom: 48px;
    border-bottom: 2px solid silver;
    padding-bottom: 5px;
  `,
  ExamTopic: styled.div`
    margin-bottom: 90px;
    font-weight: 700;
    color: #5C5C5C;
  `,
  ExamTopicNumber: styled.div`
    margin-right: 10px;
    background-color: #fff;
    border-radius: 0 20px 20px 0;
    position: absolute;
    left: -10px;
    padding: 0 10px 0 25px;
  `,
  ExamTopicContent: styled.div`
    margin-left: 24px;
  `,
  ExamTopicQuestion: styled.div`
    line-height: 40px;
    display: flex;
    background-color: #e6e6e6;
    border-radius: 15px;
    padding: 20px 55px 20px 20px;
    position: relative
  `,
  ExamTopicText: styled.div`
    margin-top: 5px;
    margin-left: 32px;
  `,
  CorrectAnswerList: styled.ul`
    list-style: disc;
  `,
  ChoosedAnswerList: styled.ul`
    color: #E98484;
    margin-top: 30px;
    list-style: disc;
  `,
  CorrectAnswer: styled.li`
    margin-left: 40px;
    font-size: 18px;
  `,
  ChoosedAnswer: styled.li`
    margin-left: 40px;
    font-size: 18px;
  `,
  Img: styled.img`
    display: flex;
    margin-top: 10px;
    &:hover {
      cursor: pointer;
    }
  `,
  AnswerTitle: styled.p`
    font-size: 18px;
    margin-bottom: 3px;
  `,
  ExamQAAnswerTitle: styled.p`
    font-size: 18px;
    margin: 20px 0 10px;
  `,
  ExamQAScore: styled.input.attrs({ type: 'text' })<{ isOver: boolean }>`
    margin: 0 2%;
    padding: 10px;
    border: 1px solid #707070;
    border-radius: 2px;
    ${props => props.isOver ? `
    border-color: #ff4d4d;
    ` : null }
  `,
  ExamQAScoreTip: styled.span`
    font-size: 12px;
    vertical-align: bottom;
  `,
  ExamQAText: styled.textarea`
    width: 95%;
    margin: 0 2%;
    padding: 10px;
    resize: none;
    min-height: 130px;
  `,
  ReviewActionContainer: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  FileOverSize: styled.p`
    text-align: center;
    margin: 20px;
    font-size: 18px;
    color: #FE4747;
  `,
  ReviewBtn: styled(Button)`
    background: #EF8200;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 7px;
    padding: 4px 27px;
  `,
  LoadingContainer: styled.div`
    display: flex;
    margin-top: 20%;
    place-content: center;
  `,
  ExamInfo: styled.ul`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 35px;
    padding: 20px 10%;
    box-shadow: 0px 6px 18px 0px #0000001f;
  `,
  ExamInfoItem: styled.li`
    text-align: center;
  `,
  ExamInfoTitle: styled.p`
    margin-bottom: 10px;
  `,
  ExamInfoValue: styled.p`
  `,
  SubmitCard: styled.div`
    border-radius: 10px;
    margin: 5%;
    padding: 3% 10% 5%;
    background-color: #fff;
    text-align: center;
  `,
  ExamReviewSubmitIcon: styled.img.attrs({ src: examReviewSubmit })`
  `,
  SubmitTitle: styled.p`
    font-size: 18px;
    margin-bottom: 40px;
  `,
  BackToHomeBtn: styled(Link)`
    background: #EF8200;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.25);
    border-radius: 7px;
    padding: 7px 30px;
    color: #fff;
  `,
  ErrorContainer: styled(Column)`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: auto;
  `,
  HightlightIcon: styled.img.attrs({ src: HightlightIcon })`
    padding-right: 10px;
  `,
  ErrorForbiddenImage: styled.img.attrs({ src: ErrorForbiddenImage })`
    width: 335px;
  `,
  ErrorText: styled.div`
    font-size: 18px;
    line-height: 30px;
    margin-top: 19px;
    margin-bottom: 32px;
    color: #313131;
  `,
  ErrorButton: styled(Button)`
    min-width: 142px;
    font-size: 18px;
    padding: 0 14px;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.25);
  `,
  FileAnswerContainer: styled.div`
    margin: 10px 2% 0;
  `,
  AnswerImg: styled.img`
    max-width: 200px;
    max-height: 200px;
  `,
  AnswerDownloadLink: styled.a`
    color: #005aff;
    text-decoration: underline;
    &:hover {
      color: blue;
    }
  `,
  AnswerFileIcon: styled.img.attrs({ src: examReviewFileIcon })`
    width: 22px;
    margin-right: 5px;
  `,
  NoWrongQuestionText: styled.p`
    text-align: center;
    margin-top: 20px;
    font-size: 20px;
    color: #434343;
  `,
  QuestionsAllCorrect: styled.img.attrs({ src: QuestionsAllCorrectIcon })`
    display: block;
    margin: 5% auto 0;
  `,
  OverText: styled.p`
    font-size: 14px;
    margin-top: 10px;
    margin-left: 2%;
    color: #FE4747;
  `,
};
